import isNull from 'lodash-es/isNull';
import { shallowEqualObjects } from 'shallow-equal';

export type MutationAffinity = TextMutationAffinity | OtherMutationAffinity;

export type OtherMutationAffinity = {
  type: 'other';
};

export const OTHER_MUTATION_AFFINITY: OtherMutationAffinity = {
  type: 'other',
};

export type TextMutationAffinity = InsertTextMutationAffinity | RemoveTextMutationAffinity;

export type InsertTextMutationAffinity = {
  type: 'insertText';
  textNode: Text;
};

export type RemoveTextMutationAffinity = {
  type: 'removeText';
  textNode: Text;
};

export function getTextMutationAffinityFromMutationRecord(
  record: MutationRecord,
): TextMutationAffinity | OtherMutationAffinity {
  if (record.type !== 'characterData' || isNull(record.oldValue)) {
    return OTHER_MUTATION_AFFINITY;
  }

  const textNode = record.target as Text;

  if (record.oldValue.length < textNode.data.length) {
    return { type: 'insertText', textNode };
  }

  return { type: 'removeText', textNode };
}

export function isMutationAffinityEqual(a: MutationAffinity, b: MutationAffinity): boolean {
  if (a.type === 'other' || b.type === 'other') {
    return false;
  }

  return shallowEqualObjects(a, b);
}
